/* eslint-disable no-unused-vars */
import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const Box = styled.div`
  display: flex;
  width: 253px;
  position: relative;

  ::after {
    content: '';
    position: absolute;
    top: 48px;
    right: 0;
    width: 1px;
    height: 388px;
    background: ${Palette.PrimaryGray._200};
  }
`;

export const Row = styled.div`
  display: inline-flex;
  flex-flow: row nowrap;
  align-items: center;
  padding-left: 24px;
  height: 40px;
  width: 100%;
`;

export const RowAndContent = styled.div``;

export const ArrowIconWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
  cursor: pointer;
  ${({ isOpen }) =>
    isOpen
      ? css`
          svg {
            fill: ${Palette.Primary._500};
          }
        `
      : css`
          svg {
            fill: ${Palette.PrimaryGray._400};
          }
        `}
`;

export const Container = styled.div`
  display: flex;
  /* border: 1px solid red; */
  align-items: center;
  background: ${Palette.PrimaryGray._000};
  padding: 0px 0px;
  ${({ withShadow }) =>
    withShadow &&
    css`
      box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.04) inset;
    `};
`;
